var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_vm._l((_vm.tags),function(tag,index){return [_c('div',{key:index,staticClass:"multiselect__tag read-only-tag",style:('background:#'+tag.tag.color.color_hex+';')},[_vm._v("\n      "+_vm._s(tag.tag.name)+"\n    ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }